export default __webpack_public_path__ + "static/font-39b7d5089a70c3ff150fe76d7d16a3eb.woff2";